import { MijnRoute } from '../../mijn-navigatie.model';

export const PAYMENT_BATCHES_BATCH_DETAILS: MijnRoute = {
    path: 'batch-details',
    navigationEvent: 'toBetaalbatchesBatchdetails',
    regex: /^\/betaalbatches\/batch-details$/,
    webcomponent: 'mijn-betalen-betaalbatches-webcomponent',
    internalPath: '/batch-details'
};
